function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import * as monaco from 'monaco-editor';
import { useTheme } from '@deephaven/components';
import { jsx as _jsx } from "react/jsx-runtime";
function Code(_ref) {
  var children = _ref.children,
    language = _ref.language;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    colorizedHtml = _useState2[0],
    setColorizedHtml = _useState2[1];
  var _useTheme = useTheme(),
    activeThemes = _useTheme.activeThemes;
  useEffect(() => {
    var isCanceled = false;
    function colorize() {
      return _colorize.apply(this, arguments);
    }
    function _colorize() {
      _colorize = _asyncToGenerator(function* () {
        if (children != null && activeThemes != null) {
          var result = yield monaco.editor.colorize(children.toString(), language, {});
          if (!isCanceled) {
            setColorizedHtml(result);
          }
        }
      });
      return _colorize.apply(this, arguments);
    }
    colorize();
    return () => {
      isCanceled = true;
    };
  }, [activeThemes, children, language]);
  return /*#__PURE__*/_jsx("div", {
    // Add pointerEvents: 'none' has huge benefits on performance with Hit Test testing on large colorized elements.
    // You can still select the text event with this set
    style: {
      pointerEvents: 'none'
    }
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: colorizedHtml != null ? {
      __html: colorizedHtml
    } : undefined
  });
}
export default Code;
//# sourceMappingURL=Code.js.map